<app-modal-template [showCancel]="true" [showSave]="false" (cancelClicked)="close()">
	<div fxLayout="column" fxFlexFill class="about-container" role="alertdialog">
		<div class="about-content mb-md">
			<!-- Logo -->
			<img class="about-icon" src="../../../../assets/images/ht-logo.png" alt="HealthTrack Logo" />

			<!-- Text -->
			<div class="about-text">
				<!-- HealthTrack Stylized Text -->
				<img class="about-ht-text-image" src="../../../../assets/images/health-track.png" alt="HealthTrack" />

				<!-- Version -->
				<div>{{ version }}</div>

				<!-- About -->
				<p>
					HealthTrack is designed by
					<a href="https://automated-health.com" target="_blank">Automated Health Systems</a>, a company
					dedicated to the Health &amp; Human Services industry since 1979.
				</p>
			</div>
		</div>
	</div>
</app-modal-template>
